import Api from './Api';

const END_POINT = 'seguros';

export default {
    async get_all(filters = null) {
        let request = {
            params: filters,
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async store(seguro) {
        return await Api.post(`${END_POINT}`, seguro)
    },
    async update(seguro) {
        return await Api.patch(`${END_POINT}/${seguro.id}`, seguro)
    },
    async change_status(seguro) {
        return await Api.patch(`${END_POINT}/${seguro.id}/change-status`, seguro)
    },
    async delete(seguro) {
        return await Api.delete(`${END_POINT}/${seguro.id}`, seguro)
    },
    async listarActivos() {
        return await Api.get('listarSegurosActivos');
    }
}